module.exports = __webpack_public_path__ + "static/Homepage-Hero1-986aff878465ec5ffea276d5a4e75ad7.jpg";